import React, { useMemo, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from '../components/Header';
import VideoPlayer from '../components/VideoPlayer';
import TrustChecklist from '../components/TrustChecklist';
import Footer from '../components/Footer';

const CDN_BASE = "https://pkgroyalstar.b-cdn.net/ShipAssure/Videos/";

export default function VideoTracker() {
  const location = useLocation();
  const [videoId, setVideoId] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get('v');
    if (id) {
      const cleanId = id.split('.')[0].replace(/[^a-zA-Z0-9_-]/g, '');
      setVideoId(cleanId);
    }
  }, [location.search]);

  const videoUrl = useMemo(() => {
    return videoId ? `${CDN_BASE}${videoId}.webm` : null;
  }, [videoId]);

  return (
    <div className="min-h-screen flex flex-col pt-8 pb-20 px-4 sm:px-6 lg:px-8">
      <div className="flex-grow flex flex-col items-center justify-center max-w-6xl mx-auto w-full">
        <Header />

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="w-full bg-white rounded-xl shadow-2xl shadow-slate-200/60 border border-slate-100 overflow-hidden flex flex-col lg:flex-row"
        >
          {/* Left Column: Video Player — black background fills full height on desktop */}
          <div className="w-full lg:w-[55%] bg-black flex items-stretch">
            <div className="w-full aspect-video lg:aspect-auto lg:h-full">
              <VideoPlayer videoUrl={videoUrl} videoId={videoId} />
            </div>
          </div>

          {/* Right Column: Trust & Information */}
          <div className="w-full lg:w-[45%] p-6 sm:p-8 lg:p-10 flex flex-col justify-center bg-white border-t lg:border-t-0 lg:border-l border-slate-100">
            <div className="mb-6">
              <div className="inline-flex items-center gap-2 px-3 py-1 bg-emerald-50 text-emerald-700 rounded-full text-xs font-bold uppercase tracking-wider mb-4 border border-emerald-100">
                <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
                Verified Shipment
              </div>
              <h2 className="text-3xl sm:text-4xl font-black text-slate-900 leading-tight tracking-tight">
                Checklist
              </h2>
              <div className="h-1.5 w-16 bg-blue-600 mt-4 rounded-full"></div>
            </div>

            <TrustChecklist />
          </div>
        </motion.div>

        <Footer />
      </div>
    </div>
  );
}